export const PAGE = 0;
export const SIZE = 50;
